<template>
  <div class="row">
    <form @submit.prevent="onSubmit" class="col-md-12" autocomplete="off">
      <PropertyForm :property="property"
        :isNewProperty="true"
        :submitting="submitting"
      >
        <template v-slot:submitForm>
          <div class='card-footer right-align-content'>
            <b-button variant="danger"
              class="button-row-spacing"
              v-b-modal="'cancelNewProperty'"
              :disabled="submitting">
              Cancel
            </b-button>
            <b-button @click="submitWrapper(property)"
              :disabled="submitting">
              Save
            </b-button>
          </div>
          <CancelModal
            :modalId="'cancelNewProperty'"
            @cancelled="cancel">
          </CancelModal>
        </template>
      </PropertyForm>
    </form>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import FormSubmit from '@/mixins/FormSubmit';
import RouterCheck from '@/mixins/RouterCheck';
import PropertyForm from '../components/PropertyForm.vue';
import CancelModal from '../components/CancelModal.vue';

export default {
  name: 'NewProperty',
  components: {
    PropertyForm,
    CancelModal,
  },
  mixins: [FormSubmit, RouterCheck],
  data() {
    return {
      property: {
        projectId: parseInt(this.$route.params.project_id, 10),
        name: '',
        acres: null,
        propertyLocalities: [
          {
            localityId: '',
            primary: true,
          },
        ],
      },
    };
  },
  created() {
    this.$store.dispatch('Common/startEditMode', 'Property');
    this.$store.dispatch('Property/fetchLatestPropertyLocality', parseInt(this.$route.params.project_id, 10))
      .then(() => {
        this.property.propertyLocalities[0].localityId = this.latestLocalityId;
      });
  },
  computed: {
    ...mapState('Property', {
      submitting: state => state.submitting,
      latestLocalityId: state => state.latestLocalityId,
    }),
  },
  methods: {
    submitWrapper(entity) {
      this.onSubmit(entity, 'Property', null, this.routeToNewProperty);
    },
    routeToNewProperty(id) {
      this.$store.dispatch('Common/stopEditMode', 'Property');
      this.$router.push({
        name: 'projectProperty',
        params: {
          project_id: parseInt(this.$route.params.project_id, 10),
          property_id: id,
        },
      });
    },
    cancel() {
      this.$store.dispatch('Common/stopEditMode', 'Property');
      this.$router.push({
        name: 'projectProperties',
        params: { project_id: parseInt(this.$route.params.project_id, 10) },
      });
    },
  },
};
</script>
